import { Button, Dialog } from '@dreamtree-org/twreact-ui';
import { warningPlace } from '../../lib/appearance';

/**
 * The pre-publish check (MERCH-55): what the server's QA found in the draft
 * (lib/store/storefrontQa), with "Go back" to fix it or "Publish anyway"
 * (publish with acknowledge_warnings). Nothing is published until the owner picks.
 */
export default function PublishCheckDialog({ warnings, doc, loading, onBack, onPublish }) {
  const open = !!(warnings && warnings.length);
  return (
    <Dialog
      isOpen={open}
      onClose={onBack}
      title="Check these before publishing"
      size="md"
      footer={(
        <div className="flex flex-wrap justify-end gap-2">
          <Button variant="outline" onClick={onBack} disabled={loading}>Go back</Button>
          <Button onClick={onPublish} loading={loading}>Publish anyway</Button>
        </div>
      )}
    >
      <p className="mb-3 text-sm opacity-80">
        Your storefront can go live like this, but shoppers would see {open && warnings.length === 1 ? 'this' : 'these'}:
      </p>
      <ul className="space-y-2" data-testid="publish-warnings">
        {open ? warnings.map((w, i) => (
          <li key={`${w.code}-${w.path}-${i}`} className="rounded-md border border-[var(--app-border)] p-2 text-sm">
            <span className="block font-medium">{warningPlace(doc, w.path)}</span>
            <span className="block opacity-80">{w.message}</span>
          </li>
        )) : null}
      </ul>
    </Dialog>
  );
}
